module.exports = __webpack_public_path__ + "img/RBY.dce2b403.svg";